import { getHoldingCompanies } from "@/helpers/holding-companies"
import * as Models from "@gigalot/data-models"

export type ConfigButtonState = "ready" | "busy" | "success" | "error" | "disabled"

export type ConfigsLocation = {
  name: string
  holdingCompany: Models.HoldingCompany
  feedlot: Models.Feedlot
}

type RunGetLocationsOptions = {
  setButtonState: (state: ConfigButtonState) => void
  setLocations: (locations: ConfigsLocation[]) => void
  setHoldingCompanies: (holdingCompanies: Models.HoldingCompany[]) => void
}

export async function runGetLocations({ setButtonState, setLocations, setHoldingCompanies }: RunGetLocationsOptions): Promise<void> {
  try {
    setButtonState("busy")
    const holdingCompanies = await getHoldingCompanies()

    const locations: ConfigsLocation[] = holdingCompanies.flatMap(hc => hc.feedlots.map(f => ({
      name: `${f.name} (${hc.name})`,
      holdingCompany: hc,
      feedlot: f
    })))

    setHoldingCompanies(holdingCompanies)
    setLocations(locations)
    setButtonState("success")
  } catch (err) {
    setButtonState("error")
    throw err
  }
}
